<template>
  <!-- 底部 -->
  <div class="footer">
    <div class="footer-links">
      <div class="container">
        <a href="https://www.gov.cn/" target="_blank">中国政府网</a>
        <a href="http://www.shandong.gov.cn/" target="_blank">山东省人民政府</a>
        <a href="https://www.miit.gov.cn/" target="_blank">工业和信息化部</a>
        <a href="http://gxt.shandong.gov.cn/" target="_blank">山东省工业和信息化厅</a>
        <a href="https://gxj.dezhou.gov.cn/" target="_blank">德州市工业和信息化局</a>
      </div>
    </div>
    <div class="footer-main">
      <div class="container">
        <div class="friend-links">
          <span class="label">友情链接</span>
          <a v-for="item in links" :href="item.url" :key="item.name" target="_blank">{{item.name}}</a>
        </div>
        <div class="footer-bottom">
          <!-- <div class="footer-logo">
            <img src="../assets/home/logo.png" alt="logo" />
          </div> -->
          <div class="footer-info">
            <div class="info-links" style="display: none;">
              <span @click="menuClick(0)">新闻中心</span> |
              <span @click="menuClick(1)">企业大厅</span> |
              <span @click="menuClick(2)">需求大厅</span> |
              <span @click="menuClick(3)">政策中心</span> |
              <span @click="menuClick(4)">活动中心</span> |
              <span @click="menuClick(5)">金融赋能</span> |
              <span @click="menuClick(6)">租房服务</span> |
              <span @click="menuClick(7)">人才供给</span>
            </div>
            <div class="info-contact">
              电话：0534-2564123 &nbsp;&nbsp; 邮箱：lxmj@126.com &nbsp;&nbsp; 地址：德州市陵城区临齐街道唐城路中段
            </div>
            <div class="info-copyright">
              版权所有：陵城区产业协同赋能平台 &nbsp;&nbsp; 鲁ICP备2026018954号 &nbsp;&nbsp; 鲁公网安备 548722126333552号
            </div>
          </div>
          <!-- <div class="footer-qr">
            <div class="qr-item">
              <div class="qr-box"></div>
              <div class="qr-label">陵企通公众号</div>
            </div>
            <div class="qr-item">
              <div class="qr-box"></div>
              <div class="qr-label">陵企通小程序</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicFooter',
  data() {
    return {
      links: [],
    }
  },
  mounted() {
    this.getLinks();
  },
  methods: {
    getLinks() {
      this.$http.get('/lc/link/list?pageNum=1&pageSize=5', { headers: { isToken: false } }).then(res => { this.links = res.rows; });
    },
    menuClick(index) {
      if (index === 0) {
        this.$router.push('/newsCenter')
      } else if (index === 1) {
        this.$router.push('/enterpriseLibrary')
      } else if (index === 2) {
        this.$router.push('/demandHall')
      } else if (index === 3) {
        this.$router.push('/policyCenter')
      } else if (index === 4) {
        this.$router.push('/activityCenter')
      } else if (index === 5) {
        this.$router.push('/financial')
      } else if (index === 6) {
        this.$router.push('/rentalService')
      } else if (index === 7) {
        this.$router.push('/talentSupply')
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer { background: #fff;
  .footer-links { background: #0D56BD; line-height: 50px;
    .container { display: flex; justify-content: center; gap: 40px; }
    a { color: #fff; font-size: 14px; text-decoration: none;
      &:hover { text-decoration: underline; }
    }
  }
  .footer-main { padding: 20px 0; width: 1200px; margin: 0 auto;
    .friend-links { display: flex; justify-content: center; gap: 16px; margin-bottom: 10px;
      .label { font-size: 14px; font-weight: bold; line-height: 20px }
      a { color: #000; font-size: 14px; text-decoration: none; line-height: 20px;
        &:hover { color: #0D56BD; }
      }
    }
    .footer-bottom { display: flex; gap: 24px; align-items: center;
      .footer-logo { flex-shrink: 0; font-size: 0;
        img { width: 160px; }
      }
      .footer-info { flex: 1;
        .info-links { font-size: 14px; margin-bottom: 8px;
          span { cursor: pointer;
            &:hover { color: #0D56BD; }
          }
        }
        .info-contact, .info-copyright { font-size: 14px; line-height: 1.8; text-align: center; }
      }
      .footer-qr { display: flex; gap: 16px;
        .qr-item { text-align: center;
          .qr-box { width: 90px; height: 90px; background: #f0f0f0; border: 1px solid #ddd; margin-bottom: 4px; }
          .qr-label { font-size: 14px; }
        }
      }
    }
  }
}
</style>
